/**
 * Enum representing various time formats. Used to format time in the application.
 *
 */
export enum TIME_FORMATS {
  // 12-hour formats
  HH_MM_AMPM = "hh:mm A", // 02:00 PM
  HH_MM_SS_AMPM = "hh:mm:ss A", // 02:00:00 PM

  // 24-hour formats
  HH_MM = "HH:mm", // 14:00
  HH_MM_SS = "HH:mm:ss", // 14:00:00

  // 12-hour formats without leading zero
  H_MM_AMPM = "h:mm A", // 2:00 PM ==> This is the default time format
  H_MM_SS_AMPM = "h:mm:ss A", // 2:00:00 PM

  // 24-hour formats without leading zero
  H_MM = "H:mm", // 14:00
  H_MM_SS = "H:mm:ss", // 14:00:00
}

// Default time format
export const DEFAULT_TIME_FORMAT = TIME_FORMATS.H_MM_AMPM;
